export default {
    auth: {
        signup: '/auth/signup',
        signin: '/auth/signin',
        finish: '/auth/finish',
    },
    wallet: {
        transaction: '/wallet/transaction',
        export: '/wallet/export',
        safe: '/wallet/safe',
        check: '/wallet/check',
        token: '/wallet/contract/token',
        tokenToggle: '/wallet/contract/token/token-toggle',
        getTokens: '/wallet/contract/token/get-tokens',
        setToken: '/wallet/contract/token/set-token',
        getDeployPrice: '/wallet/contract/token/deploy-price',
    },
    inbox: {
        channelInfo: '/inbox/channel/info',
        channelOwner: '/inbox/channel/owner',
        channelBlock: '/inbox/channel/block',
        channelInfoUpdate: '/inbox/channel/info/update',
        channelGuide: '/inbox/channel/guide',
        channelCreate: '/inbox/channel/create',
        channelList: '/inbox/channel/list',
        channelConnected: '/inbox/channel/connected',
        channelUnconnected: '/inbox/channel/unconnected',
        channelDelete: '/inbox/channel/delete',
        messageSend: '/inbox/message/send',
        messageList: '/inbox/message/list',
        messageDelete: '/inbox/message/delete',
        messagePrivateSend: '/inbox/message/private/send',
        messageRead: '/inbox/message/read'
    },
    account: {
        info: '/account/info',
        update: '/account/update',
        detecting: '/account/detecting/list'
    },
    message: {
        send: '/message/send',
        list: '/message/list',
        delete: '/message/delete',
        getPoll: '/message/get-poll',
        setPoll: '/message/set-poll'
    },
    article: {
        view: '/article/view',
        list: '/article/list',
        editor: '/article/editor',
        delete: '/article/delete',
        getCreatePrice: '/article/create-price'
    },
    contact: {
        get: '/contact/get',
        set: '/contact/set',
        delete: '/contact/delete',
        check: '/contact/check',
    },
    storage: {
        upload: '/storage/upload'
    },
    explorer: {
        getTransaction: '/explorer/get-transaction',
        getTransactions: '/explorer/get-transactions',
        getAccounts: '/explorer/get-accounts',
        getTotalsupply: '/explorer/get-totalsupply',
        getDifficulty: '/explorer/get-difficulty'
    },
    status: '/status'
};
